import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full flex flex-col gap-1.5" data-id="element-62">
      {label && <label htmlFor={inputId} className="text-sm font-medium text-navy" data-id="element-63">
          {label}
        </label>}
      <input id={inputId} className={`flex min-h-[44px] w-full rounded-md border border-silver bg-white px-3 py-2 text-sm placeholder:text-silver focus:outline-none focus:ring-2 focus:ring-red focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${className}`} {...props} data-id="element-64" />
      {error && <span className="text-xs text-red-500" data-id="element-65">{error}</span>}
    </div>;
}